import React from "react";
import { Link } from "react-router-dom";
import moment from "moment-timezone";
import "moment/locale/es";

export const getOrdersVialBillingColumns = () => [
  {
    name: "Folio ",
    selector: (row) => (
      <>
        <div className="mb-2 text-center">
          <Link to={`/orders-vial/editOrder/${row.id}`}>{row.folio}</Link>
        </div>
        <div
          className="d-flex flex-column align-items-center"
          style={{ width: "120px" }}
        >
          <Link
            to={`/facturacion-varo-express/carta-porte/${row.id}`}
            className="btn btn-secondary btn-sm w-100"
          >
            Carta Porte
          </Link>
        </div>
      </>
    ),
    sortable: true,
    sortField: "folio",
    width: "12%",
  },
  {
    name: (
      <>
        Fecha y Hora <br /> de la Orden
      </>
    ),
    selector: (row) =>
      row.fecha_hora_orden && (
        <>
          {moment
            .utc(row.fecha_hora_orden)
            .locale("es")
            .format("DD/MMM/YYYY")}
          <br />
          {moment
            .utc(row.fecha_hora_orden)
            .locale("es")
            .format("hh:mm a")}
        </>
      ),
    sortable: true,
    sortField: "fecha_hora_orden",
    width: "12%",
  },
  {
    name: "Expediente",
    selector: (row) => row.expedienteNo,
    sortable: true,
    sortField: "expedienteNo",
    width: "12%",
  },
  {
    name: "Infracción",
    selector: (row) => row.infraccionNo,
    sortable: true,
    sortField: "infraccionNo",
    width: "12%",
  },
  {
    name: "Cliente",
    selector: (row) => row.nombreInfractor,
    sortable: true,
    sortField: "nombreInfractor",
    width: "16%",
  },
  {
    name: "Estatus",
    selector: (row) => (
      <span
        className={`ms-1 mb-1 badge border px-2 pt-5px pb-5px rounded fs-12px d-inline-flex align-items-center ${
          row.estatus === "Cancelado"
            ? "border-danger text-danger"
            : "border-success text-success"
        }`}
      >
        {row.estatus}
      </span>
    ),
    sortable: true,
    sortField: "estatus",
    width: "10%",
  },
  {
    name: "Total",
    selector: (row) => `$${parseFloat(row.total || 0).toFixed(2)}`,
    sortable: true,
    sortField: "total",
    width: "10%",
  },
  {
    name: (
      <>
        Carta Porte <br /> timbrada
      </>
    ),
    selector: (row) =>
      row.stamped_cartaportes?.length > 0 ? (
        <span className="ms-1 mb-1 badge border border-success text-success px-2 pt-5px pb-5px rounded fs-12px d-inline-flex align-items-center">
          Sí ({row.stamped_cartaportes.length})
        </span>
      ) : (
        <span className="ms-1 mb-1 badge border border-secondary text-secondary px-2 pt-5px pb-5px rounded fs-12px d-inline-flex align-items-center">
          Sin timbrar
        </span>
      ),
    sortable: false,
    width: "12%",
  },
];

export const customStyles = {
  headCells: {
    style: {
      color: "#202124",
      fontSize: "14px",
      backgroundColor: "#EEEEEE",
      border: "none",
    },
  },
};
